<template>
  <b-modal
    title="Choix de la taille de colonne"
    size="xl"
    :modal-class="'base-modal middle-size'"
    :no-close-on-backdrop="true"
    :no-close-on-esc="true"
    centered
    ref="colonneModal"
  >
    <b-container fluid>
      <b-row class="mb-1 text-center">
        <b-col cols="4" class="item">
          <b-button @click="colonneClick('col-12')" class="btn-item">
            <div class="h-100 w-100 choice">
              1/1
            </div>
          </b-button>
        </b-col>
        <b-col cols="4" class="item">
          <b-button @click="colonneClick('col-6')" class="btn-item">
            <div class="h-100 w-50 choice">
              1/2
            </div>
          </b-button>
        </b-col>
        <b-col cols="4" class="item">
          <b-button @click="colonneClick('col-3')" class="btn-item">
            <div class="h-100 w-25 choice">
              1/4
            </div>
          </b-button>
        </b-col>
        <b-col cols="4" class="item">
          <b-button @click="colonneClick('col-9')" class="btn-item">
            <div class="h-100 w-75 choice">
              3/4
            </div>
          </b-button>
        </b-col>
        <b-col cols="4" @click="colonneClick('col')" class="item">
          <b-button class="btn-item">
            <div class="h-100 w-100 choice">
              Auto
            </div>
          </b-button>
        </b-col>
      </b-row>
    </b-container>

    <div slot="modal-footer" class="w-100">
      <b-button variant="primary" size="lg" class="float-right" @click="close">
        Annuler
      </b-button>
    </div>
  </b-modal>
</template>

<script>
export default {
  props: {
    conteneurIndex: Number
  },
  methods: {
    close () {
      this.$refs['colonneModal'].hide()
    },
    colonneClick (colSize) {
      this.$emit('colonneClick', { colSize, index: this.conteneurIndex })
      this.$refs['colonneModal'].hide()
    },
    open () {
      this.$refs['colonneModal'].show()
    }
  }
}
</script>

<style lang="scss" scoped>
.item {
  margin-bottom: 30px;
  .btn-item {
    padding: 5px;
    border-radius: 0;
    border: 1px dashed #d2d3e5;
    background-color: #fff;
    height: 128px;
    width: 100%;
    color: whitesmoke;
    &:hover {
      color: whitesmoke;
      border-color: #2b3085;
    }
    .choice {
      background-color: #d2d3e5;
      text-align: center;
      padding: 25% 0;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/ficheEspace/modal/selectionColonne.vue